import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './styles';

const TextInput = ({ id, item, handleChange, value, handleBlur, error }) => {
    const { label, optional, message, typeInput } = item;

    return (
        <Container
            label={`${label}${optional ? '' : '*'}`}
            value={value || ''}
            variant="outlined"
            type={typeInput}
            onChange={(e) => handleChange(e)}
            helperText={error || message}
            error={!!error}
            onBlur={handleBlur}
            id={id}
            name={id}
        />
    );
};

TextInput.propTypes = {
    item: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    value: PropTypes.any,
    error: PropTypes.string,
    id: PropTypes.string
};

export default TextInput;
